import { Box, Typography } from "@mui/material";
import styles from "../css/StepInfo.module.css";

interface LoginInfoProps {
    headerText: string;
    infoText: React.ReactElement;
    screenshot: any;
    active: boolean;
    containerDataTestId: string;
    headerTextDataTestId: string;
    screenshotDataTestId: string;
}

export const StepInfo = ({headerText, infoText, screenshot, active, containerDataTestId, headerTextDataTestId, screenshotDataTestId}: LoginInfoProps) => {
    return (
        <Box
            sx={{
                display: active ? "block" : "none",
            }}
            data-testid={containerDataTestId}
        >
            <Typography variant="h2" className={styles.headerText} data-testid={headerTextDataTestId}>{headerText}</Typography>
            {
                infoText
            }
            <img src={screenshot} alt="Bottom Bar Icon" className={styles.loginImage} data-testid={screenshotDataTestId} />
        </Box>
    )
}